export const THEME_NAME_TO_ID = {
  Dawn: "dawn",
  Sense: "sense",
  Craft: "craft",
  Fresh: "fresh",
  Empire: "empire",
  Bloom: "bloom",
  Circuit: "circuit",
  Slate: "slate",
  Grove: "grove",
  Tide: "tide",
  Aurora: "aurora",
  Spice: "spice",
  Regal: "regal",
  Meadow: "meadow",
  Pantry: "pantry",
  Atelier: "atelier",
  Remedy: "remedy",
  Forge: "forge",
  Ovenly: "ovenly",
  Harvest: "harvest",
  "Apple Electronic": "apple",
  "Samsung Electronic": "samsung",
  LuxeGlow: "luxeglow",
  "Glow Aura": "glowaura",
  "Flora Nectar": "floranectar",
  "Silky Clay": "silkyclay",
  Vitality: "vitality",
  Breeze: "breeze",
  Urban: "urban",
  Eclipse: "eclipse",
  MobiTech: "mobitech",
  "Google Pixel": "pixel",
  OnePlus: "oneplus",
  Vortex: "vortex",
  "Studio Noir": "studionoir",
};

const BASE_PRESET = {
  heroVariant: "classic",
  productVariant: "grid",
  cardVariant: "clean",
  hideBanner: true,
  pageClass: "bg-slate-50",
  contentClass: "",
  navClass: "bg-white border-b border-gray-200 shadow-sm",
  tabsVariant: "underline",
  heroShellClass: "",
  mainSurfaceClass: "",
  productPageVariant: "balanced",
  productPageSurfaceClass: "bg-white",
  introClass: "bg-white/90 border-b border-gray-200",
  introText: "Explore our curated catalog",
  productSectionClass: "",
};

export const STOREFRONT_THEME_PRESETS = {
  dawn: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "dawn",
    pageClass: "bg-gradient-to-b from-sky-50 via-slate-50 to-white",
    navClass: "bg-white/95 backdrop-blur border-b border-blue-100 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "",
    mainSurfaceClass: "",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white/90",
    introClass: "bg-sky-50 border-b border-sky-100",
    introText: "Fresh and modern shopping with clean surfaces",
    productSectionClass: "",
  },
  sense: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "editorial",
    cardVariant: "fashion",
    pageClass: "bg-gradient-to-b from-violet-100/70 via-fuchsia-50 to-white",
    navClass: "bg-violet-950 text-white border-b border-violet-800 shadow-lg",
    tabsVariant: "pills",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-violet-200 shadow-xl",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6 mb-6",
    productPageVariant: "gallery-right",
    productPageSurfaceClass: "bg-violet-50/80",
    introClass: "bg-violet-100/80 border-b border-violet-200",
    introText: "Bold editorial storefront for storytelling brands",
    productSectionClass: "",
  },
  craft: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "craft",
    pageClass: "bg-amber-50",
    navClass: "bg-amber-100 border-b border-amber-300 shadow-sm",
    tabsVariant: "boxed",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-amber-50/60",
    introClass: "bg-amber-100 border-b border-amber-200",
    introText: "Handmade collections with uneven artisan flow",
    productSectionClass: "",
  },
  fresh: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "carousel",
    cardVariant: "fresh",
    pageClass: "bg-emerald-50",
    navClass: "bg-emerald-900 text-white border-b border-emerald-700 shadow-md",
    tabsVariant: "pills",
    heroShellClass: "",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "immersive",
    productPageSurfaceClass: "bg-emerald-50/60",
    introClass: "bg-emerald-100 border-b border-emerald-200",
    introText: "Swipe-first showcase for fast moving products",
    productSectionClass: "",
  },
  empire: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "editorial",
    cardVariant: "luxury",
    pageClass: "bg-neutral-900",
    contentClass: "text-gray-100",
    navClass: "bg-black text-gray-100 border-b border-neutral-700 shadow-lg",
    tabsVariant: "dark",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-2xl overflow-hidden border border-neutral-700",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6",
    productPageVariant: "gallery-right",
    productPageSurfaceClass: "bg-neutral-900",
    introClass: "bg-neutral-800 border-b border-neutral-700",
    introText: "Luxury visual rhythm with large feature cards",
    productSectionClass: "",
  },
  bloom: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "beauty",
    pageClass: "bg-rose-50",
    navClass: "bg-rose-100 border-b border-rose-200 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4 rounded-[2rem] overflow-hidden",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-rose-50/60",
    introClass: "bg-rose-100 border-b border-rose-200",
    introText: "Soft beauty storefront with floating product rhythm",
    productSectionClass: "",
  },
  circuit: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "carousel",
    cardVariant: "tech",
    pageClass: "bg-cyan-50",
    navClass: "bg-cyan-950 text-cyan-100 border-b border-cyan-800 shadow-md",
    tabsVariant: "boxed",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "immersive",
    productPageSurfaceClass: "bg-cyan-50/70",
    introClass: "bg-cyan-100 border-b border-cyan-200",
    introText: "Tech-forward modular layout and horizontal catalog",
    productSectionClass: "",
  },
  slate: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "grid",
    cardVariant: "dark",
    pageClass: "bg-gray-900",
    contentClass: "text-gray-100",
    navClass: "bg-gray-950 text-gray-100 border-b border-gray-700 shadow-lg",
    tabsVariant: "dark",
    heroShellClass: "",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-5",
    productPageVariant: "minimal-dark",
    productPageSurfaceClass: "bg-gray-900",
    introClass: "bg-gray-800 border-b border-gray-700",
    introText: "Dark storefront with clean product blocks",
    productSectionClass: "",
  },
  grove: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "organic",
    pageClass: "bg-lime-50",
    navClass: "bg-lime-100 border-b border-lime-300 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4 rounded-2xl overflow-hidden",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-lime-50/70",
    introClass: "bg-lime-100 border-b border-lime-200",
    introText: "Organic layout inspired by natural market browsing",
    productSectionClass: "",
  },
  tide: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "carousel",
    cardVariant: "coastal",
    pageClass: "bg-sky-50",
    navClass: "bg-sky-900 text-sky-100 border-b border-sky-700 shadow-sm",
    tabsVariant: "pills",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "immersive",
    productPageSurfaceClass: "bg-sky-50/70",
    introClass: "bg-sky-100 border-b border-sky-200",
    introText: "Ocean-inspired swipe catalog with airy sections",
    productSectionClass: "",
  },
  aurora: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "editorial",
    cardVariant: "creative",
    pageClass: "bg-indigo-50",
    navClass: "bg-indigo-950 text-indigo-100 border-b border-indigo-800 shadow-md",
    tabsVariant: "boxed",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-indigo-200",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "gallery-right",
    productPageSurfaceClass: "bg-indigo-50/70",
    introClass: "bg-indigo-100 border-b border-indigo-200",
    introText: "Creative high-impact grid with dramatic lead cards",
    productSectionClass: "",
  },
  spice: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "bold",
    pageClass: "bg-orange-50",
    navClass: "bg-orange-200 border-b border-orange-300 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-orange-50/70",
    introClass: "bg-orange-100 border-b border-orange-200",
    introText: "Bold restaurant-inspired storefront with punchy blocks",
    productSectionClass: "",
  },
  regal: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "editorial",
    cardVariant: "luxury",
    pageClass: "bg-amber-50",
    navClass: "bg-amber-900 text-amber-100 border-b border-amber-700 shadow-md",
    tabsVariant: "boxed",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-amber-200",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "gallery-right",
    productPageSurfaceClass: "bg-amber-50/70",
    introClass: "bg-amber-100 border-b border-amber-200",
    introText: "Premium showcase built for jewelry and luxury catalogs",
    productSectionClass: "",
  },
  meadow: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "organic",
    pageClass: "bg-green-50",
    navClass: "bg-green-100 border-b border-green-300 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4 rounded-2xl overflow-hidden",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-green-50/70",
    introClass: "bg-green-100 border-b border-green-200",
    introText: "Calm botanical storefront for nursery and garden brands",
    productSectionClass: "",
  },
  pantry: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "pantry",
    pageClass: "bg-gradient-to-b from-amber-50 via-orange-50 to-stone-100",
    navClass: "bg-[#fff9f0]/95 backdrop-blur border-b border-amber-200 shadow-sm",
    tabsVariant: "boxed",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4 rounded-[2rem] overflow-hidden border border-amber-200 shadow-lg",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-amber-50/70",
    introClass: "bg-amber-100 border-b border-amber-200",
    introText: "Pantry shelves and staple-first browsing with warm merchandising",
    productSectionClass: "",
  },
  atelier: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "editorial",
    cardVariant: "fashion",
    pageClass: "bg-gradient-to-b from-rose-50 via-stone-50 to-white",
    navClass: "bg-zinc-950 text-rose-50 border-b border-rose-300/20 shadow-lg",
    tabsVariant: "pills",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-rose-200 shadow-xl",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6 mb-6",
    productPageVariant: "gallery-right",
    productPageSurfaceClass: "bg-rose-50/70",
    introClass: "bg-rose-100 border-b border-rose-200",
    introText: "Tailored lookbooks for apparel and textile collections",
    productSectionClass: "",
  },
  remedy: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "clean",
    pageClass: "bg-teal-50",
    navClass: "bg-white/95 backdrop-blur border-b border-teal-200 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4 rounded-3xl overflow-hidden border border-teal-100 shadow-md",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-teal-100/80 border-b border-teal-200",
    introText: "Clear pharmacy-first layout with trusted product information",
    productSectionClass: "",
  },
  forge: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "grid",
    cardVariant: "tech",
    pageClass: "bg-slate-100",
    navClass: "bg-slate-900 text-slate-100 border-b border-amber-400/30 shadow-md",
    tabsVariant: "boxed",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-slate-300 shadow-xl",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-slate-100/80",
    introClass: "bg-amber-50 border-b border-amber-200",
    introText: "Industrial storefront for machinery, tools, and bulk parts",
    productSectionClass: "",
  },
  ovenly: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "craft",
    pageClass: "bg-orange-50",
    navClass: "bg-orange-100 border-b border-orange-200 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4 rounded-[2rem] overflow-hidden border border-orange-200 shadow-lg",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-orange-50/70",
    introClass: "bg-amber-50 border-b border-amber-200",
    introText: "Bakery counters and fresh batches with warm merchandising",
    productSectionClass: "",
  },
  harvest: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "organic",
    pageClass: "bg-gradient-to-b from-lime-50 via-yellow-50 to-white",
    navClass: "bg-lime-100 border-b border-lime-300 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4 rounded-3xl overflow-hidden border border-lime-200 shadow-lg",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-lime-50/70",
    introClass: "bg-yellow-50 border-b border-yellow-200",
    introText: "Field-to-shelf storytelling for farms and agri brands",
    productSectionClass: "",
  },
  apple: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "clean",
    pageClass: "bg-[#f5f5f7]",
    navClass: "bg-white/80 backdrop-blur-md border-b border-gray-200/50 shadow-sm",
    tabsVariant: "underline",
    heroShellClass: "max-w-6xl mx-auto px-4 mt-4",
    mainSurfaceClass: "max-w-6xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-white border-b border-gray-200",
    introText: "Minimal elegance, premium performance.",
    productSectionClass: "",
  },
  samsung: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "carousel",
    cardVariant: "tech",
    pageClass: "bg-[#040814]",
    contentClass: "text-slate-100",
    navClass: "bg-[#040814]/90 backdrop-blur-xl border-b border-slate-800 shadow-2xl",
    tabsVariant: "pills",
    heroShellClass: "max-w-6xl mx-auto px-4 mt-4 rounded-3xl overflow-hidden border border-slate-800 shadow-2xl",
    mainSurfaceClass: "max-w-6xl mx-auto px-4",
    productPageVariant: "immersive",
    productPageSurfaceClass: "bg-[#040814]",
    introClass: "bg-slate-900 border-b border-slate-800",
    introText: "Future-ready technology and seamless design.",
    productSectionClass: "",
  },
  luxeglow: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "organic",
    pageClass: "bg-[#faf6f0]",
    navClass: "bg-[#faf6f0]/90 backdrop-blur-md border-b border-[#e5dcd0] shadow-sm",
    tabsVariant: "pills",
    heroShellClass: "max-w-6xl mx-auto px-4 mt-4 rounded-[2.5rem] overflow-hidden border border-[#ebdcc8] shadow-md",
    mainSurfaceClass: "max-w-6xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-white border-b border-[#ebdcc8]/30",
    introText: "Nourish your skin with ultra-pure botanical formulations.",
    productSectionClass: "",
  },
  glowaura: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "grid",
    cardVariant: "creative",
    pageClass: "bg-[#fafafc]",
    navClass: "bg-[#fafafc]/80 backdrop-blur-md border-b border-purple-100 shadow-sm",
    tabsVariant: "pills",
    heroShellClass: "max-w-6xl mx-auto px-4 mt-4 rounded-3xl overflow-hidden border border-purple-50 shadow-[0_20px_50px_rgba(217,70,239,0.06)]",
    mainSurfaceClass: "max-w-6xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-white border-b border-purple-50",
    introText: "Light up your skin's vital energy.",
    productSectionClass: "",
  },
  floranectar: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "organic",
    pageClass: "bg-[#faf8f5]",
    navClass: "bg-[#faf8f5]/90 backdrop-blur-md border-b border-[#e1dcd1] shadow-sm",
    tabsVariant: "underline",
    heroShellClass: "max-w-6xl mx-auto px-4 mt-4 rounded-3xl overflow-hidden border border-[#e1dcd1] shadow-sm",
    mainSurfaceClass: "max-w-6xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-[#f5f2eb] border-b border-[#e1dcd1]/50",
    introText: "Botanical elixirs sourced by earth, proven by science.",
    productSectionClass: "",
  },
  silkyclay: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "clean",
    pageClass: "bg-[#fbf9f6]",
    navClass: "bg-[#fbf9f6]/95 border-b border-[#e1d3c7] shadow-sm",
    tabsVariant: "underline",
    heroShellClass: "max-w-6xl mx-auto px-4 mt-4 rounded-2xl overflow-hidden border border-[#e1d3c7] shadow-sm",
    mainSurfaceClass: "max-w-6xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-[#faf6f2] border-b border-[#e1d3c7]/50",
    introText: "Purify and balance with mineral-rich clay deposits.",
    productSectionClass: "",
  },
  vitality: {
    ...BASE_PRESET,
    heroVariant: "classic",
    productVariant: "masonry",
    cardVariant: "organic",
    pageClass: "bg-[#f0fdf4]",
    navClass: "bg-emerald-900 text-emerald-100 border-b border-emerald-700 shadow-sm",
    tabsVariant: "soft",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-emerald-50/70",
    introClass: "bg-emerald-100 border-b border-emerald-200",
    introText: "Active wellness and fitness collections",
    productSectionClass: "",
  },
  breeze: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "carousel",
    cardVariant: "coastal",
    pageClass: "bg-[#ecfeff]",
    navClass: "bg-cyan-900 text-cyan-100 border-b border-cyan-700 shadow-sm",
    tabsVariant: "pills",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-4",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "immersive",
    productPageSurfaceClass: "bg-cyan-50/70",
    introClass: "bg-cyan-100 border-b border-cyan-200",
    introText: "Light airy lifestyle curated catalog",
    productSectionClass: "",
  },
  urban: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "grid",
    cardVariant: "clean",
    pageClass: "bg-[#f9fafb]",
    navClass: "bg-gray-900 text-gray-100 border-b border-gray-700 shadow-sm",
    tabsVariant: "underline",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-gray-200 shadow-sm",
    mainSurfaceClass: "max-w-7xl mx-auto px-4",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-gray-100 border-b border-gray-200",
    introText: "Sleek and minimalist city essentials",
    productSectionClass: "",
  },
  eclipse: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "grid",
    cardVariant: "dark",
    pageClass: "bg-[#020617] text-slate-100",
    contentClass: "text-slate-100",
    navClass: "bg-[#020617]/95 text-slate-100 border-b border-slate-800/80 shadow-lg",
    tabsVariant: "dark",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-slate-800/60 shadow-[0_20px_50px_rgba(16,185,129,0.08)]",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6",
    productPageVariant: "minimal-dark",
    productPageSurfaceClass: "bg-[#020617]",
    introClass: "bg-slate-900/60 border-b border-slate-800",
    introText: "Step into the darkness. Brightened by modern rhythm.",
    productSectionClass: "",
  },
  mobitech: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "grid",
    cardVariant: "dark",
    pageClass: "bg-[#090d16] text-slate-100",
    contentClass: "text-slate-100",
    navClass: "bg-[#090d16]/95 text-slate-100 border-b border-slate-800/80 shadow-lg",
    tabsVariant: "dark",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-slate-800/60 shadow-[0_20px_50px_rgba(37,99,235,0.08)]",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6",
    productPageVariant: "minimal-dark",
    productPageSurfaceClass: "bg-[#090d16]",
    introClass: "bg-slate-900/60 border-b border-slate-800",
    introText: "Ultra-sleek tech layout with dynamic device showcases.",
    productSectionClass: "",
  },
  pixel: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "clean",
    pageClass: "bg-[#f8f9fa] text-[#3c4043]",
    contentClass: "text-[#3c4043]",
    navClass: "bg-white/90 backdrop-blur border-b border-gray-200 shadow-sm",
    tabsVariant: "underline",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-gray-200/60 shadow-sm",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-white border-b border-gray-150",
    introText: "Experience intelligence designed by Google.",
    productSectionClass: "",
  },
  oneplus: {
    ...BASE_PRESET,
    heroVariant: "overlay",
    productVariant: "grid",
    cardVariant: "dark",
    pageClass: "bg-[#0f172a] text-slate-200",
    contentClass: "text-slate-200",
    navClass: "bg-[#0f172a]/95 text-slate-100 border-b border-slate-800 shadow-lg",
    tabsVariant: "dark",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-slate-800/80 shadow-[0_20px_50px_rgba(235,0,40,0.06)]",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6",
    productPageVariant: "minimal-dark",
    productPageSurfaceClass: "bg-[#0f172a]",
    introClass: "bg-slate-900/80 border-b border-slate-800",
    introText: "Never Settle. Fast and smooth e-commerce experience.",
    productSectionClass: "",
  },
  vortex: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "glass",
    pageClass: "bg-[#03000a] text-slate-200",
    contentClass: "text-slate-200",
    navClass: "bg-[#03000a]/90 text-slate-100 border-b border-[#c084fc]/15 shadow-lg",
    tabsVariant: "dark",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 rounded-3xl overflow-hidden border border-[#c084fc]/15 shadow-[0_8px_32px_rgba(217,70,239,0.08)]",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6",
    productPageVariant: "minimal-dark",
    productPageSurfaceClass: "bg-[#03000a]",
    introClass: "bg-[#080214] border-b border-[#c084fc]/10",
    introText: "Futuristic neon shopping experiences.",
    productSectionClass: "",
  },
  studionoir: {
    ...BASE_PRESET,
    heroVariant: "split",
    productVariant: "grid",
    cardVariant: "clean",
    pageClass: "bg-[#fafafa] text-[#121212]",
    contentClass: "text-[#121212]",
    navClass: "bg-white/95 text-neutral-900 border-b border-neutral-200 shadow-sm",
    tabsVariant: "underline",
    heroShellClass: "max-w-7xl mx-auto px-4 mt-5 border border-neutral-200 shadow-sm",
    mainSurfaceClass: "max-w-7xl mx-auto px-4 mt-6",
    productPageVariant: "balanced",
    productPageSurfaceClass: "bg-white",
    introClass: "bg-white border-b border-neutral-100",
    introText: "High contrast monochrome design curation.",
    productSectionClass: "",
  },
};

export const resolveThemeId = (theme = {}) => {
  if (theme.themeId) return theme.themeId;
  if (theme.themeName && THEME_NAME_TO_ID[theme.themeName]) return THEME_NAME_TO_ID[theme.themeName];
  return "";
};

export const getStorefrontThemePreset = (theme = {}) => {
  const themeId = resolveThemeId(theme);
  return STOREFRONT_THEME_PRESETS[themeId] || BASE_PRESET;
};